<ng-content select="fui-name-value-list-entry"></ng-content>
@if (entries.length) {
    <fui-empty [description]="emptyDescription" [title]="emptyTitle"></fui-empty>
}
